/**
 * Lightweight tenant-scope flag, importable from anywhere without
 * pulling cloudSync or tenantContext (avoids circular imports in
 * `src/data/catalog.ts`, `src/stores/deviceSettingsStore.ts`, etc.).
 *
 * The flag is set by `setCloudSyncTenantScope()` whenever the active
 * tenant changes. Modules that render built-in catalog/brand/category
 * data check this flag and skip platform built-ins for tenant scopes —
 * tenants start truly empty and only see what the Store Manager imports
 * or adds.
 */
let _scope: string | null = null;

export function setActiveTenantScope(scope: string | null): void {
  _scope = scope;
}

export function getActiveTenantScope(): string | null {
  return _scope;
}

export function isTenantContext(): boolean {
  return _scope !== null;
}
